/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

 /**
  * author: hao
  */

import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import Logon from '../views/Logon'
import Agreement from '../views/Agreement'
import Help from '../views/Help'
import AccountQuestion from '../views/AccountQuestion'
import PreviewQuestion from '../views/PreviewQuestion'
import BasicInfo from '../views/BasicInfo'
import FileUploadInfo from '../views/FileUploadInfo'
import AOForm from '../views/AOForm'
import AOFormReview from '../views/AOFormReview'
import Appointment from '../views/Appointment'
import ConfirmPQ from '../views/ConfirmPQ'
import SystemErrorMessage from '../views/SystemErrorMessage'
import ApplicantInformation from '../views/ApplicantInformation';
import CompanyRegistration from '../views/CompanyRegistration';
import AccountOpeningSteps from '../views/AccountOpeningSteps';

import paths from '../config/path'

const Routers = (props) => (
    <div role="main" className="main-container">
        <Switch>
            <Route exact path={paths.root.path} component= { Logon } />
            <Route exact path={paths.logon.path} component= { Logon } />
            <Route path={paths.agreement.path} component={ Agreement } />
            <Route path={paths.help.path} component={ Help } />
            <Route path={paths.basicInfo.path} component={ BasicInfo } />
            <Route path={paths.accountQuestion.path} component={ AccountQuestion } />
            <Route path={paths.previewQuestion.path} component={ PreviewQuestion } />
            <Route path={paths.appointment.path} component={ Appointment } />
            <Route path={paths.file_upload_info.static_path} component={ FileUploadInfo } />
            <Route path={paths.aoform.static_path} component={ AOForm } />
            <Route path={paths.confirmPQ.path} component={ ConfirmPQ } />
            <Route path={paths.applicantInformation.path} component={ ApplicantInformation } />
            <Route path={paths.companyRegistration.path} component={ CompanyRegistration } />
            <Route path={paths.accountOpeningSteps.path} component={ AccountOpeningSteps } />
            <Route path={paths.dashboard.path} component={ AOFormReview } />
            <Route path={paths.systemErrorMessage.path} component={ SystemErrorMessage } />
            <Route path="/template/*.*" />
            <Route path="/images/*.*" />

            <Redirect to={paths.root.path} />
        </Switch>
    </div>
);

export default Routers





// WEBPACK FOOTER //
// ./src/router/router.js